import {Injectable} from '@angular/core';
import {LoadScriptService} from './load-script.service';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, delay, map, retryWhen, take} from 'rxjs/operators';

declare var twttr: Twitter;

interface Twitter {
    events: any;

    ready(callback: any): void;

    init(config: any): void;

    login(callback: any, permissions: any): void;

    getAuthResponse(config: any): void;

    getLoginStatus(config: any): void;
}

@Injectable({
    providedIn: 'root'
})
export class TwitterService {
    error: any;
    appId: string;
    isLoaded = false;
    isInitialize = false;

    constructor(
        private httpClient: HttpClient,
        loadScript: LoadScriptService,
    ) {
        loadScript.get('https://platform.twitter.com/widgets.js').subscribe(response => {
            this.isLoaded = true;
        }, error => {
            this.error = error;
        });
    }

    initialize(appId: string): Observable<boolean> {
        this.appId = appId;

        return Observable.create(observer => {
            if (this.error) {
                observer.error(this.error);
            } else if (!this.isLoaded) {
                observer.error(new Error('Twitter SDK is not loaded'));
            } else {
                observer.next(true);
            }

            observer.complete();
        }).pipe(
            map(() => this.initializeSDK()),
            retryWhen(error => error.pipe(
                delay(200),
                take(25),
            )),
            catchError(error => of(error))
        );
    }

    findManageablePage(): Observable<any> {
        const loadError = this.validateSDK();
        if (loadError) {
            return of(loadError);
        }

        return Observable.create(observer => {
            this.getAuthentification().subscribe(response => {
                if (response && response.userID) {
                    this.listAccessiblePage(response.userID).subscribe(pages => {
                        observer.next(pages);
                        observer.complete();
                    }, error => {
                        observer.error(error);
                    });
                } else {
                    observer.error(new Error('No user are connected to Facebook'));
                }
            }, error => {
                observer.error(error);
            });
        });
    }

    askToManagePage(): Observable<any> {
        const loadError = this.validateSDK();
        if (loadError) {
            return of(loadError);
        }

        return Observable.create(observer => {
            this.getAuthentification().subscribe(() => {
                this.askTokenWithScope('manage_pages, publish_pages').subscribe(response => {
                    this.listAccessiblePage(response.userID).subscribe(pages => {
                        observer.next(pages);
                        observer.complete();
                    }, error => {
                        observer.error(error);
                    });
                }, error => {
                    observer.error(error);
                });
            }, error => {
                observer.error(error);
            });
        });
    }

    publishToPage(pageId: string, accessToken: string, message: string): Observable<any> {
        return this.httpClient.post(`https://graph.facebook.com/${pageId}/feed`, {
            message: message,
            access_token: accessToken,
        });
    }

    private listAccessiblePage(userId: string): Observable<any> {
        return Observable.create(observer => {
            /*FB.api(`/${userId}/accounts`, (response: any) => {
                if (response && !response.error) {
                    observer.next(response.data);
                } else {
                    observer.error(response);
                }

                observer.complete();
            });*/
        });
    }

    private askTokenWithScope(scope: string): Observable<any> {
        return Observable.create(observer => {
            /*FB.login((response: any) => {
                observer.next(response.authResponse);
                observer.complete();
            }, {
                scope: scope,
            });*/
        });
    }

    private getAuthentification(): Observable<any> {
        return Observable.create(observer => {
            /*FB.getLoginStatus((response: any) => {
                if (response.authResponse) {
                    observer.next(response.authResponse);
                } else {
                    observer.error(new Error('No facebook connection'));
                }

                observer.complete();
            });*/
        });
    }

    private initializeSDK() {
        twttr.ready(() => {
            this.isInitialize = true;
        });
    }

    private validateSDK() {
        if (!this.isInitialize) {
            return new Error('You need to initialize the service');
        }

        return false;
    }
}
